import { faCheck, faXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import { ListItem, ListItemIcon, ListItemText, List, Box, Popper } from "@mui/material";
import { Condition } from "@shared/mirage/validators/PasswordValidator";

interface PasswordPopperProps {
    anchorElement: HTMLElement;
    conditions: Condition[];
}

const PasswordPopper = (props: PasswordPopperProps) => {
    const { anchorElement, conditions } = props;

    const getStyles = () => {
        const anchorElementWidth = parseInt(window.getComputedStyle(anchorElement).width);
        const popperWidth = anchorElementWidth - 30;
        const pseudoElementsStyles = {
            content: '""',
            position: "absolute",
            width: 0,
            height: 0,
            borderWidth: "10px",
            borderStyle: "solid",
            left: "50%",
            transform: "translate(-50%, 0)",
        };

        return {
            width: popperWidth + "px",
            background: "#f7f7f7",
            marginTop: "20px",
            borderRadius: "4px",
            border: `1px solid ${MirageTheme.palette.grey[400]}`,
            padding: "15px",
            zIndex: "9000",
            "::before": {
                ...pseudoElementsStyles,
                zIndex: "10000",
                borderColor: `transparent transparent ${MirageTheme.palette.grey[400]} transparent`,
                top: "0px",
            },
            "::after": {
                ...pseudoElementsStyles,
                zIndex: "11000",
                borderColor: "transparent transparent #f7f7f7 transparent",
                top: "1px",
            },
        };
    };

    const getContent = (conditions: Condition[]) => {
        const getListItem = (condition: Condition) => {
            const iconSize = MirageTheme.icons.sizeS;
            const successColor = MirageTheme.palette.success.main;
            const errorColor = MirageTheme.palette.error.main;

            return (
                <ListItem dense disablePadding key={condition.name}>
                    <ListItemIcon sx={{ minWidth: "min-content", paddingRight: "16px" }}>
                        {condition.passed ? (
                            <FontAwesomeIcon icon={faCheck} style={iconSize} color={successColor} />
                        ) : (
                            <FontAwesomeIcon icon={faXmark} style={iconSize} color={errorColor} />
                        )}
                    </ListItemIcon>
                    <ListItemText sx={{ fontSize: "0.875rem", color: condition.passed ? successColor : errorColor }} disableTypography>
                        {condition.name}
                    </ListItemText>
                </ListItem>
            );
        };

        return <List disablePadding>{conditions.map((condition) => getListItem(condition))}</List>;
    };

    return (
        <Popper open={true} anchorEl={anchorElement} sx={{ zIndex: "999999" }}>
            <Box id="password-popper" sx={getStyles()}>
                {getContent(conditions)}
            </Box>
        </Popper>
    );
};

export default PasswordPopper;
